var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrow3 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 130,
    viewBox: "0 0 141 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03893 125.951C0.934568 125.929 0.0218784 126.807 0.000378847 127.911C-0.0211205 129.016 0.856712 129.928 1.96107 129.95L2.03893 125.951ZM130 0L117.099 19.1544L140.138 20.75L130 0ZM2 127.95L1.96107 129.95C38.3613 130.659 68.446 123.898 90.5342 106.191C112.659 88.456 126.414 60.0211 130.747 18.1498L128.757 17.944L126.768 17.7381C122.504 58.9487 109.051 86.2212 88.0324 103.07C66.9768 119.949 37.9812 126.65 2.03893 125.951L2 127.95Z",
    fill: "#FF671F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrow3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Arrow3.ae2f685aefacea2322e991b6233c7171.svg";